import React from 'react'

//import ChatHeaderStats from '../../ChatHeaderStats'
import MobileInboxSelect from '../MobileInboxSelect'
import ConversationListV2 from '../../../../components/organisms/ConversationsV2/ConversationListV2'
import LoadingList from '../../../../components/organisms/ConversationsV2/LoadingList'
import FloatingActionButtonV2 from '../../../../components/atoms/FloatingActionButtonV2'
import NewConversationModal from '../../../../components/organisms/ConversationsV2/NewConversation'

import { MobileClientChatProps } from '../MobileClientChats'

interface MobileQueueProps
  extends Omit<MobileClientChatProps, 'openMergeModal' | 'children'> {
  loaded: boolean
}

const MobileQueue: React.FC<MobileQueueProps> = ({ loaded }) => {
  const [open, setOpen] = React.useState(false)

  const handleNewChatClick = React.useCallback(() => {
    setOpen(true)
  }, [])

  const handleCloseModal = React.useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <>
      {/* <ChatHeaderStats mobile /> */}

      <MobileInboxSelect />

      {loaded ? <ConversationListV2 mobile /> : <LoadingList mobile />}

      {loaded && <FloatingActionButtonV2 onClick={handleNewChatClick} />}

      {open && <NewConversationModal onClose={handleCloseModal} />}
    </>
  )
}

export default MobileQueue
